<script>
import RichText from "./RichText.vue";

export default {
  name: "FaqContainer",
  components: {RichText},
  props: ["faqs"]
}
</script>

<template>
<v-expansion-panels accordion multiple>
  <v-expansion-panel v-for="(item, i) in faqs" :key="i">
    <v-expansion-panel-header class="expansion-panel-header-custom">
      {{ item.Question }}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <rich-text
          v-if="item.Answer"
          :source="item.Answer"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</v-expansion-panels>
</template>

<style scoped>

</style>